// extracted by mini-css-extract-plugin
export default {"colorBlock":"QQWf2jKStiWg4TvFgKaC","color":"oJPBX84ztCjPUdeWQMop","texture":"ewVNhLwHLlabYO2UsOvH"};